var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _g, _g2, _g3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 94,
    viewBox: "0 0 144 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.0312 79.2896C89.8181 81.9118 83.9295 83.3882 77.6961 83.3882C56.3616 83.3882 39.0665 66.0931 39.0665 44.7585C39.0665 23.424 56.3616 6.12891 77.6961 6.12891C99.0307 6.12891 116.326 23.424 116.326 44.7585C116.326 53.949 113.116 62.3899 107.757 69.0215L110.956 79.5133L112.636 85.0261L107.157 83.2406L95.0312 79.2896Z",
    stroke: "#F4B652",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3157 28.2946C82.3157 32.042 85.4485 35.1748 89.1959 35.1748C92.9433 35.1748 96.0761 32.042 96.0761 28.2946",
    stroke: "#F4B652",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7607 28.2946C56.7607 32.042 59.7816 35.1748 63.3952 35.1748C67.0088 35.1748 70.0297 32.042 70.0297 28.2946",
    stroke: "#F4B652",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5553 56.43C68.5553 52.6826 71.688 49.5498 75.4355 49.5498C79.1829 49.5498 82.3157 52.6826 82.3157 56.43",
    stroke: "#F4B652",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.5673,
    height: 11.7946,
    rx: 5.89732,
    transform: "matrix(1 0 0 -1 28.8589 47.1416)",
    fill: "#FF2A60",
    fillOpacity: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 53.5673,
    height: 11.7946,
    rx: 5.89732,
    transform: "matrix(1 0 0 -1 62.4 59.1211)",
    fill: "#FF2A60",
    fillOpacity: 0.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 53.5673,
    height: 11.3032,
    rx: 5.6516,
    transform: "matrix(1 0 0 -1 35.5671 70.1299)",
    fill: "#FF2A60",
    fillOpacity: 0.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.65 10.1662C109.512 10.0292 109.326 9.95237 109.132 9.95237C108.937 9.95237 108.751 10.0292 108.613 10.1662C108.476 10.3046 108.399 10.4914 108.399 10.6861C108.399 10.8808 108.476 11.0676 108.613 11.206L110.709 13.3009L108.615 15.396C108.478 15.5339 108.402 15.7203 108.402 15.9147C108.402 16.109 108.478 16.2955 108.615 16.4333C108.753 16.5703 108.94 16.6472 109.134 16.6472C109.328 16.6472 109.515 16.5703 109.653 16.4333L111.747 14.3385L113.841 16.4312C113.978 16.5682 114.165 16.645 114.359 16.645C114.554 16.645 114.74 16.5682 114.878 16.4312C115.015 16.2933 115.092 16.1069 115.092 15.9125C115.092 15.7182 115.015 15.5317 114.878 15.3938L112.785 13.3001L114.88 11.2033C115.017 11.0655 115.094 10.879 115.094 10.6847C115.094 10.4903 115.017 10.3039 114.88 10.166C114.593 9.88087 114.125 9.88087 113.84 10.166L111.746 12.2623L109.65 10.166L109.65 10.1662Z",
    fill: "#FF2A60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_88_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.064 86.5266C137.926 86.3896 137.74 86.3127 137.545 86.3127C137.351 86.3127 137.164 86.3896 137.027 86.5266C136.89 86.6649 136.813 86.8517 136.813 87.0464C136.813 87.2412 136.89 87.428 137.027 87.5663L139.122 89.6612L137.029 91.7563C136.892 91.8942 136.815 92.0807 136.815 92.275C136.815 92.4694 136.892 92.6558 137.029 92.7937C137.167 92.9307 137.353 93.0075 137.548 93.0075C137.742 93.0075 137.928 92.9307 138.066 92.7937L140.16 90.6988L142.254 92.7915C142.392 92.9285 142.579 93.0054 142.773 93.0054C142.967 93.0054 143.154 92.9285 143.292 92.7915C143.429 92.6537 143.505 92.4672 143.505 92.2729C143.505 92.0785 143.429 91.892 143.292 91.7542L141.198 89.6605L143.294 87.5637C143.431 87.4258 143.508 87.2394 143.508 87.045C143.508 86.8507 143.431 86.6642 143.294 86.5263C143.006 86.2412 142.539 86.2412 142.254 86.5263L140.16 88.6226L138.064 86.5263L138.064 86.5266Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_88_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9852 21.6662C32.8473 21.5292 32.6608 21.4524 32.4665 21.4524C32.2721 21.4524 32.0857 21.5292 31.9478 21.6662C31.8108 21.8046 31.7339 21.9914 31.7339 22.1861C31.7339 22.3808 31.8108 22.5676 31.9478 22.706L34.0434 24.8009L31.9502 26.896C31.8132 27.0339 31.7364 27.2203 31.7364 27.4147C31.7364 27.609 31.8132 27.7955 31.9502 27.9333C32.0881 28.0703 32.2745 28.1472 32.4689 28.1472C32.6632 28.1472 32.8497 28.0703 32.9876 27.9333L35.0815 25.8385L37.1754 27.9312C37.3133 28.0682 37.4997 28.145 37.6941 28.145C37.8884 28.145 38.0749 28.0682 38.2128 27.9312C38.3497 27.7933 38.4266 27.6069 38.4266 27.4125C38.4266 27.2182 38.3497 27.0317 38.2128 26.8938L36.1193 24.8001L38.2149 22.7033C38.3519 22.5655 38.4288 22.379 38.4288 22.1847C38.4288 21.9903 38.3519 21.8039 38.2149 21.666C37.9274 21.3809 37.4603 21.3809 37.1752 21.666L35.0812 23.7623L32.9849 21.666L32.9852 21.6662Z",
    fill: "#FF2A60"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 8.27073,
    height: 8.27073,
    rx: 4.13536,
    transform: "matrix(1 0 0 -1 42.7545 11.9932)",
    stroke: "#F4B652",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 8.27073,
    height: 8.27073,
    rx: 4.13536,
    transform: "matrix(1 0 0 -1 115.586 78.5967)",
    stroke: "#F4B652",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 8.27073,
    height: 8.27073,
    rx: 4.13536,
    transform: "matrix(1 0 0 -1 33.1713 78.5967)",
    stroke: "#F4B652",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 8.27073,
    height: 8.27073,
    rx: 4.13536,
    transform: "matrix(1 0 0 -1 3.00916 43.4453)",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.66651,
    height: 7.66651,
    fill: "white",
    transform: "translate(107.92 9.47266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_88_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.66651,
    height: 7.66651,
    fill: "white",
    transform: "translate(136.333 85.833)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_88_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.66651,
    height: 7.66651,
    fill: "white",
    transform: "translate(31.2547 20.9727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.0894c47a2ed6b8159cb4e97fb1f9cb13.svg";
export { ForwardRef as ReactComponent };